import React from 'react';
import Box from '@mui/material/Box';
import { Modal as MuiModal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import css from './Modal.module.scss';

type TModal = {
  children: React.ReactNode;
  isOpen: boolean;
  handleClose: () => void;
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 567,
  bgcolor: 'background.paper',
  borderRadius: '7px',
  boxShadow: 4,
  p: 4,
  outline: 'none !important',
};

export const Modal = ({ children, isOpen, handleClose }: TModal) => {
  return (
    <MuiModal
      open={isOpen}
      className={css.root}
      sx={{
        '& > .MuiBackdrop-root': {
          opacity: '0 !important',
        },
      }}
    >
      <Box sx={style}>
        {children}
        <CloseIcon className={css.close} onClick={handleClose} />
      </Box>
    </MuiModal>
  );
};
